module.exports = __webpack_public_path__ + "static/media/1022701.897a7c1f.jpg";